<template>
  <div class="main-content">
    <div class="title">
      <img class="icon" src="./assets/icon_file.png" alt="icon" />
      <div class="name">大中专毕业档案查询</div>
    </div>
    <div class="search-wrapper">
      <div class="label">姓名:</div>

      <el-input v-model="name" placeholder="请输入查找姓名"></el-input>
      <el-button type="primary" @click="getStudentList">查询</el-button>
    </div>
    <div class="content">
      <div v-if="!hasData" class="table-wrapper">
        <el-table :data="studentList">
          <el-table-column type="index" width="80" label="序号">
          </el-table-column>
          <el-table-column class="spclass" prop="name" label="姓名" width="200">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="200">
          </el-table-column>
          <el-table-column
            prop="graduateSchool"
            label="毕业学校"
          ></el-table-column>
          <el-table-column prop="schoolCode" label="档案编号"></el-table-column>
        </el-table>
        <div class="pagination-wrapper">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="10"
          ></el-pagination>
        </div>
      </div>
      <div v-if="hasData" class="nodata-wrapper">
        <img class="nodata-bg" src="./assets/nodata.png" alt="nodata" />
        <p class="tip">输入姓名查询后就会显示数据咯~</p>
      </div>
      <ul v-if="hasData" class="tip-txt">
        <li>益阳籍高校毕业生调档、查询须知</li>
        <li>
          一、档案查询请登录：湖南省大学生就业网或益阳教育网或湖南人事代理网。
        </li>
        <li>注：2016年后本省毕业生档案查询以湖南人事代理网查询为主。</li>
        <li>
          二、领取档案请本人出示接收单位调档函和本人身份证，委托他人办理者请出示委托书和代领人身份证。调档函单位名称：益阳市大中专学校学生信息咨询与就业指导中心。地址：湖南省益阳市赫山区桃花仑西路685号；咨询电话：0737-4216556。
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
function _xhr(url, data, fn) {
  var xhr = new XMLHttpRequest();
  xhr.open("post", url, true);
  xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == 200) {
      fn.call(this, JSON.parse(xhr.responseText));
    }
  };
  xhr.send(JSON.stringify(data));
}
// import axios from "axios";
// import vuers from "vue-resource";
export default {
  name: "App",
  data() {
    return {
      name: null,
      hasData: true,
      studentList: [],
    };
  },
  methods: {
    getStudentList() {
      if (!this.name) {
        this.$message({
          message: "请输入您要查找的姓名",
          type: "warning",
        });
        this.hasData = true;
        this.studentList = [];
      } else {
        let data = {
          name: this.name,
          pageNumber: 1,
          pageSize: 999,
        };

        _xhr(
          "https://zhx.edu.yiyang.gov.cn/cloudcampus_wxgzh/specialschool/getStudentList.do",
          data,
          (response) => {
            if (response.data.length === 0) {
              this.hasData = true;
              this.studentList = [];
              this.$message({
                message: "没有您要查找的人",
                type: "warning",
              });
            } else {
              this.hasData = false;
              this.studentList = response.data;
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="scss">
.main-content {
  width: 1134px;
  min-height: 580px;
  background-color: #fff;
  margin: 27px 33px;
  .title {
    margin-bottom: 31px;
    .icon {
      display: inline-block;
      width: 21px;
      height: 20px;
      margin-right: 16px;
      vertical-align: text-bottom;
    }
    .name {
      display: inline-block;
      font-size: 18px;
      font-weight: 400;
      color: #2b8cee;
    }
  }

  .search-wrapper {
    display: flex;
    .label {
      line-height: 36px;
      font-size: 14px;
      font-weight: 400;
      color: #323333;
      margin-right: 10px;
    }

    .el-input {
      width: 180px;
      margin-right: 33px;
      .el-input__inner {
        height: 36px;
        line-height: 36px;
      }
    }

    .el-button {
      width: 86px;
      padding: 0;
      font-size: 16px;
      line-height: 36px;
      height: 36px;
    }
  }

  .content {
    position: relative;
    .nodata-wrapper {
      position: absolute;
      top: 50%;
      left: 60%;
      transform: translate(-50%, 30%);
      .nodata-bg {
        display: block;
        width: 254px;
        height: 196px;
      }
      .tip {
        margin: 12px 0px 0px 0px;
        width: 254px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
      }
    }

    .tip-txt {
      width: 1000px;
      margin: 0;
      padding: 0;
      color: #333333;
      font-size: 13px;
      line-height: 24px;
      list-style: none;
      position: fixed;
      bottom: 30px;
    }

    .table-wrapper {
      margin-top: 40px;
      .pagination-wrapper {
        width: 100%;
        margin-top: 20px;
        text-align: center;
      }

      .el-table {
        height: 490px;
        overflow-y: auto;
      }

      .el-table__header-wrapper {
        .has-gutter th {
          &:first-child {
            .cell {
              text-align: center;
              padding-left: 0px;
            }
          }
        }
      }

      .el-table__body-wrapper {
        .el-table__row td {
          &:first-child {
            .cell {
              text-align: center;
              padding-left: 0px;
            }
          }
        }
      }

      .el-table th {
        background-color: #e3f1ff;
        padding: 0;
        height: 39px;
        line-height: 39px;
      }

      .el-table th > .cell {
        font-size: 14px;
        font-weight: 400;
      }

      .el-table--enable-row-transition .el-table__body td {
        padding: 0px;
        height: 39px;
        line-height: 39px;
        background: rgb(249, 249, 249);
      }
      .el-table td,
      .el-table th.is-leaf {
        border-bottom: 0px;
      }

      .el-table:before {
        height: 0;
      }
    }
  }
}
</style>
